import { render, staticRenderFns } from "./CollectionToIndex.vue?vue&type=template&id=07cb589e&"
import script from "./CollectionToIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionToIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports